export default class Errors {
  constructor(errors) {
    this.errors = errors || {}
  }

  get(field, all = false) {
    if (this.errors[field]) {
      if (typeof this.errors[field] === "string" || all) {
        return this.errors[field]
      }
      return this.errors[field][0]
    }
  }

  toArray() {
    const errors = []

    if (!this.any()) {
      return errors
    }

    Object.keys(this.errors).map((key) => {
      const data = this.errors[key]
      data.map((e) => {
        errors.push(e)
      })
    })

    return errors
  }

  first(field) {
    return this.get(field)
  }

  getAll(field) {
    return this.get(field, true)
  }

  set(errors) {
    this.errors = errors
  }

  clear(field) {
    if (typeof field === "undefined") {
      // Clear all errors by creating a new empty object
      this.errors = {}
    } else {
      this.errors = { ...this.errors }
      delete this.errors[field]
    }
  }

  has(field) {
    return Object.prototype.hasOwnProperty.call(this.errors, field)
  }

  any() {
    return this.count() > 0
  }

  // this allows us to search errors
  // we pass in a searchString and this function returns the first error whose
  // key includes that string or null if no matches
  firstIncludes(searchString) {
    for (const key in this.errors) {
      if (key.includes(searchString)) {
        return this.get(key)
      }
    }
    return null
  }

  count() {
    return Object.keys(this.errors).length
  }

  push(field, errors) {
    this.errors[field] = Array.isArray(errors) ? errors : [errors]
  }

  clearAll() {
    this.errors = {}
  }

  static firstMessageFromResponse(error) {
    const data = error?.response?.data
    if (!data || typeof data !== "object") {
      return null
    }
    for (const value of Object.values(data)) {
      if (Array.isArray(value) && value.length > 0 && typeof value[0] === "string") {
        return value[0]
      }
      if (typeof value === "string" && value.length > 0) {
        return value
      }
    }
    return null
  }
}
